export default "/confirmation-loader.e7b1895f7e20a70ed2e89db359a4612f.svg";